export const STAGES_STEPS = {
    MEDIA: "MEDIA",
    TEMPLATE: "TEMPLATE",
    INFO: "INFO",
    OTP: "OTP"
};
